import { render, staticRenderFns } from "./SolutionsEdit.vue?vue&type=template&id=113189d2&scoped=true"
import script from "./SolutionsEdit.vue?vue&type=script&lang=js"
export * from "./SolutionsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113189d2",
  null
  
)

export default component.exports